import { ProfileService } from 'client/services';
import GeoJSON from 'ol/format/GeoJSON';

const action = async ({ request }) => {
    const rawFormData = await request.formData();
    const formData = Object.fromEntries(rawFormData);

    switch (request.method.toUpperCase()) {
        case 'PUT': {
            const name = formData.name;
            const mapExtent = formData.mapExtent ? formData.mapExtent.split(',') : undefined;
            const geometry = formData.geometry ? JSON.parse(formData.geometry) : undefined;
            const bufferRadiusMetres = formData.bufferRadiusMetres ? Number(formData.bufferRadiusMetres) : undefined;
            if (name && (mapExtent || geometry)) {
                try {
                    const createdBookmark = await ProfileService.postBookmark(name, mapExtent, geometry, bufferRadiusMetres);
                    return { createdBookmark, createdBookmarkError: false };
                } catch (err) {
                    return { createdBookmark: null, createdBookmarkError: true };
                }
            }
            break;
        }
        case 'POST': {
            // postback to map page during create observation (and eventually we'll fold i2d back into here too)
            const draftObservation = JSON.parse(formData.draftObservation) || {};
            const geometry = draftObservation.geometry;
            const aoi = new GeoJSON().readFeature({ geometry, type: 'Feature' });
            return { draftObservation, aoi };
        }
    }
    return {};
};

export default action;
